const AppLayout = (resolve) =>
  require(['@/components/layout/AppLayout'], resolve);
const _import = (path, subPath) =>
  require('@/components/page/meetingplan/' +
    path +
    (subPath ? `/${subPath}/index` : '/index'));

const routes = {
  path: '/meetingplan',
  component: AppLayout,
  meta: {
    title: 'meetingplan',
    hidden: true
  },
  redirect: 'application',
  children: [
    {
      path: 'application',
      name: 'meetingplan-application',
      meta: {
        title: 'meetingplan.application'
      },
      component: _import('application')
    },
    {
      path: 'task',
      name: 'meetingplan-task',
      meta: {
        title: 'meetingplan.task',
      },
      component: _import('task')
    },
    {
      path: 'library',
      name: 'meetingplan-library',
      meta: {
        title: 'meetingplan.library',
      },
      component: _import('library')
    },
    {
      path: 'application/add/:year/:season',
      name: 'meetingplan-application-add',
      meta: {
        title: 'meetingplan.application.add',
        pagetitle: '添加会议',
        innerPage: true,
        hasInnerBottom: true,
      },
      component: _import('application','edit')
    },
    {
      path: 'application/copy/:id',
      name: 'meetingplan-application-copy',
      meta: {
        title: 'meetingplan.application.copy',
        pagetitle: '复制会议',
        hidden: true,
        innerPage: true,
        hasInnerBottom: true,
      },
      component: _import('application','edit')
    },
    {
      path: 'application/edit/:id',
      name: 'meetingplan-application-edit',
      meta: {
        title: 'meetingplan.application.edit',
        pagetitle: '编辑会议',
        hidden: true,
        innerPage: true,
        hasInnerBottom: true,
      },
      component: _import('application','edit')
    },
    {
      path: 'application/change/:id',
      name: 'meetingplan-application-change',
      meta: {
        title: 'meetingplan.application.change',
        pagetitle: '变更会议',
        hidden: true,
        innerPage: true,
        hasInnerBottom: true,
      },
      component: _import('application','edit')
    },
    {
      path: 'application/view/:id',
      name: 'meetingplan-application-view',
      meta: {
        title: 'meetingplan.application.view',
        pagetitle: '查看会议',
        hidden: true,
        innerPage: true,
      },
      component: _import('application','view')
    },
    {
      path: 'application/viewchange/:id',
      name: 'meetingplan-application-viewchange',
      meta: {
        title: 'meetingplan.application.viewchange',
        pagetitle: '查看会议',
        hidden: true,
        innerPage: true,
        hasInnerBottom: true,
      },
      component: _import('application','view')
    },
    {
      path: 'task/view/:id',
      name: 'meetingplan-task-view',
      meta: {
        title: 'meetingplan.task.view',
        pagetitle: '查看任务',
        hidden: true,
        innerPage: true,
        hasInnerBottom: true,
      },
      component: _import('task','view')
    },
    {
      path: 'library/view/:id',
      name: 'meetingplan-library-view',
      meta: {
        title: 'meetingplan.library.view',
        pagetitle: '查看计划库',
        hidden: true,
        innerPage: true,
        hasInnerBottom: true,
      },
      component: _import('library','view')
    }
  ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/meetingplan.js